import React from "react";
import PublicationFacet from "./publicationFacet/publicationFacet";
import "./publicationFacets.scss";

const PublicationsFacets = ({ searchFacets, onFacetChanged }) => {

    return (
        <div className="px-3 px-md-0 sections-sidebar">
            <div className="side-facet">
                {Object.entries(searchFacets).map(
                    ([key, facetList]) =>
                        <>
                            {
                                facetList.length > 0 &&
                                <PublicationFacet
                                    facet={{facetKey: key, facetList: facetList}}
                                    onFacetChange={onFacetChanged}>
                                </PublicationFacet>
                            }
                        </>

                )}
            </div>
        </div>
    )
}

export default PublicationsFacets;
